import { render, staticRenderFns } from "./VacationEmployeeAttendance.vue?vue&type=template&id=2a58e0ff&scoped=true"
import script from "./VacationEmployeeAttendance.vue?vue&type=script&lang=js"
export * from "./VacationEmployeeAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a58e0ff",
  null
  
)

export default component.exports